export const token_addresses = {
  customTokenAddress:"0xd753c12650c280383Ce873Cc3a898F6f53973d16",
  composerAddress:"0xCb9A588a47DD0393af3d0d5F86E6F1c8FD252c48",
  registryAddress:"something"
}
